module.exports = __webpack_public_path__ + "media/images/prismic_catalog/presentation_cards/categories/beauty-c3ddb166e1b87987212d825d1fce6d68.png";